function findInnermostCommonParentElement(htmlElement: HTMLElement) {
  function traverse(element: ChildNode) {
    if (
      element.nodeType === Node.ELEMENT_NODE &&
      element.childNodes.length === 1 &&
      element.firstChild &&
      element.firstChild.nodeType === Node.ELEMENT_NODE
    ) {
      return traverse(element.firstChild);
    }
    // element is a innermost common parent if it has !== 1 children or non-node child(ren)
    return element;
  }

  return traverse(htmlElement);
}

export function replaceAndPreserveInnermostParentHtmlElement(
  newContent: string,
  maybeHtmlContent: string,
): string {
  const parser = new DOMParser();
  const sanitizedText = newContent.replace(/(<([^>]+)>)/gi, '');
  const htmlDoc = parser.parseFromString(maybeHtmlContent, 'text/html');

  const errNode = htmlDoc.querySelector('parsererror');

  if (!errNode) {
    findInnermostCommonParentElement(htmlDoc.body).textContent = sanitizedText;
    return htmlDoc.body.innerHTML;
  }

  return sanitizedText;
}
